export const chats = {
  chatListChatIfoAttachmentsText: 'Prisegtas(-i) failas(-ai)',
  chatListChatNoMessagesText: 'Dar nėra žinučių',
  chatArchivedTitle: 'Archyvuoti pokalbiai',
  chatsCreatePrivateCurtainTitle: 'Naujas pokalbis',
  chatsCreatePrivateCurtaiSearchInputPlaceholder: 'Paieška',
  chatsCreatePrivateCurtainCreateButtonTitle: 'Sukurti',
  chatCreateButtonTitle: 'Kitas',
  chatCreateNewGroupHeader: 'Nauja grupė',
  chatGroupNameInputTitle: 'Grupės pavadinimas',
  chatLogoTitle: 'Redaguoti',
  chatCreateGroupButtonTitle: 'Sukurti grupę',
  chatRequiredFieldsAlert: 'Būtina nurodyti grupės pavadinimą!',
  chatsCreateGroupChatLongTitleAlertText: 'Pavadinimas per ilgas!',
  chatsCreateGroupChatLBigImageAlertText: 'Pasirinkite mažesnį paveikslėlį!',
  chatsNewChatInputPlaceholder: 'Rašykite žinutę',
  chatsNewChatAddedBigImageAlertText: 'Pasirinkite mažesnį paveikslėlį!',
  chatOwnersArchiveOptionText: 'Archyvuoti',
  chatOwnersEditGroupOptionText: 'Redaguoti',
  chatOwnersManageGroupOptionText: 'Tvarkyti narius',
  chatOwnersChangeGroupOptionText: 'Pakeisti savininką',
  chatOwnersLeaveGroupOptionText: 'Palikti',
  chatOwnersDeleteGroupOptionText: 'Ištrinti pokalbį',
  chatpopupArchivedTitle: 'Archyvuoti pokalbį',
  chatpopupArchivedDescription: 'Ar tikrai norite tai padaryti?',
  chatArchiveGroupButtonTitleYes: 'Patvirtinti',
  chatArchiveGroupButtonTitleCancel: 'Atšaukti',
  chatEditGroupHeader: 'Redaguoti pokalbį',
  chatEditGroupEditLogoTitle: 'Redaguoti',
  chatEditGroupButtonTitle: 'Išsaugoti',
  chatGroupEditAlertText: 'Sėkmingai išsaugota!',
  chatManageGroupHeader: 'Tvarkyti',
  chatManageGroupButtonTitle: 'Pridėti narį',
  chatManageGroupSaveButtonTitle: 'Išsaugoti',
  chatAddUsersGroupHeader: 'Pridėti narius',
  chatAddUsersGroupButtonTitle: 'Patvirtinti',
  chatAddUsersGroupSearchInputPlaceholder: 'Paieška',
  chatOwnershipTransferHeader: 'Perduoti nuosavybę',
  chatOwnershipTransferSearchInputPlaceholder: 'Paieška',
  chatOwnershipTransferButtonTitle: 'Patvirtinti',
  chatOwnerMarkText: '(jūs)',
  chatOwnershipTransferAlertText: 'Nuosavybė perduota!',
  chatOwnerLeaveGroupTitle: 'Palikti grupę',
  chatOwnerLeaveGroupDescription: 'Jūs esate pokalbio savininkas, todėl pirmiausia turite paskirti naują savininką.',
  chatOwnerLeaveGroupButtonTitleYes: 'Pasirinkti',
  chatOwnerLeaveGroupButtonTitleNo: 'Atšaukti',
  chatsGroupChatUsersCurtanArchOptionTitle: 'Archyvuoti',
  chatsGroupChatUsersCurtanMembersOptionTitle: 'Pokalbio nariai',
  chatsGroupChatUsersCurtanLeaveOptionTitle: 'Palikti',
  chatsGroupChatMemberCurtainTitle: 'Pokalbio nariai',
  chatsGroupChatMemberCurtainSearchInputPlaceholder: 'Paieška',
  chatsGroupChatMemberCurtainOwnerMarkText: '(savininkas)',
  chatsGroupChatLeavePopupTitle: 'Palikti',
  chatsGroupChatLeavePopupText: 'Ar tikrai norite išeiti?',
  chatsGroupChatLeavePopupCancelButtonTitle: 'Atšaukti',
  chatsGroupChatLeavePopupConfirmButtonTitle: 'Patvirtinti',
  chatDeleteGroupTitle: 'Ištrinti pokalbį',
  chatDeleteGroupDescription: 'Pokalbis ir visa jo istorija bus ištrinti visiems dalyviams. Tęsti?',
  chatDeleteGroupButtonTitleYes: 'Patvirtinti',
  chatDeleteGroupButtonTitleNo: 'Atšaukti',
  chatsPrivateChatCurtainArchOptionTitle: 'Archyvuoti',
  chatsEditMessage: 'Redaguoti žinutę',
  chatsCopyMessage: 'Kopijuoti žinutę',
  chatsDeleteMessage: 'Ištrinti žinutę',
  chatsSelectMessage: 'Pasirinkti žinutę',
  chatMarkTextEdit: '(redaguota)',
  chatCopyMessageAlertText: 'Žinutė nukopijuota!',
  chatDeleteMessageTitle: 'Ištrinti žinutę',
  chatDeleteMessageDescription: 'Ištrinti šią žinutę?',
  chatDeleteMessageButtonTitleYes: 'Patvirtinti',
  chatDeleteMessageButtonTitleNo: 'Atšaukti',
  chatSelectButtonDelete: 'Atšaukti',
  chatSelectButtonNo: 'Ištrinti',
  chatDeleteMessagesTitle: 'Ištrinti žinutes',
  chatDeleteMessagesDescription: 'Ištrinti šias žinutes?',
  chatDeleteMessagesButtonTitleYes: 'Patvirtinti',
  chatDeleteMessagesButtonTitleNo: 'Atšaukti',
  chatArchiveButtonRestore: 'Atkurti',
  chatArchiveButtonNo: 'Ištrinti',
  chatNoUsersCurtainTitle: 'Ups!',
  chatsNoUsersCurtainText: 'Atrodo, kad nėra kitų naudotojų. Pakvieskite draugų ir pradėkite pokalbį.',
  chatsNoUsersCurtainCancelButtonTitle: 'Atšaukti',
  chatsNoUsersCurtainCopyButtonTitle: 'Kopijuoti programos nuorodą',
  chatsAppLinkCopiedAlertText: 'Nuoroda nukopijuota!',
  chatsTooFewUsers: 'Pasirinkite bent vieną naudotoją, kad pradėtumėte pokalbį!',
  chatsError: 'Įvyko klaida!'
}
